import React from 'react'
import Post from '../Components/Post'
import TopSection from '../Components/TopSection'

const Home = () => {
    return (
        <div>
            <TopSection />
            <Post />
        </div>
    )
}

export default Home
